import api from '../client'
import { uploadMediaAsset } from '../mediaUpload'

export const mediaApi = {
  list: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/media`, { params })
    return response.data
  },
  get: async (orgSlug, id) => {
    const response = await api.get(`/${orgSlug}/media/${id}`)
    return response.data
  },
  updateMetadata: async (orgSlug, id, metadata) => {
    const response = await api.patch(`/${orgSlug}/media/${id}`, { metadata })
    return response.data
  },
  delete: async (orgSlug, id, force = false) => {
    const response = await api.delete(`/${orgSlug}/media/${id}${force ? '?force=true' : ''}`)
    return response.data
  }
}

export const mediaIngestApi = {
  start: async (orgSlug, payload) => {
    const response = await api.post(`/${orgSlug}/media/ingest`, payload)
    return response.data
  },
  getStatus: async (orgSlug, assetId) => {
    const response = await api.get(`/${orgSlug}/media/ingest/${assetId}`)
    return response.data
  },
}

export const mediaLibraryApi = {
  listAssets: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/media-assets`, { params })
    return response.data
  },
  createAsset: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/media-assets`, data)
    return response.data
  },
  updateAsset: async (orgSlug, id, data) => {
    const response = await api.patch(`/${orgSlug}/media-assets/${id}`, data)
    return response.data
  },
  deleteAsset: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/media-assets/${id}`)
    return response.data
  },
  // Deletes up to BATCH_MEDIA_ASSET_LIMIT assets, one server transaction
  // each; the result lists every id as deleted, missing, in_use or failed.
  deleteAssets: async (orgSlug, assetIds) => {
    const response = await api.post(`/${orgSlug}/media-assets/batch-delete`, { asset_ids: assetIds })
    return response.data
  },
  uploadAsset: async (orgSlug, file, fields = {}, options = {}) => {
    return uploadMediaAsset(api, `/${orgSlug}/media-assets/uploads`, file, fields, options)
  },
  // Caption files are sidecar WebVTT tracks of a post's video: they are
  // stored on the media CDN without a media library entry.
  uploadCaptionTrack: async (orgSlug, file) => {
    const formData = new FormData()
    formData.append('file', file, file.name)
    const response = await api.post(`/${orgSlug}/media-assets/captions`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data.caption
  },
  listTemplates: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/media-templates`, { params })
    return response.data
  },
  createTemplate: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/media-templates`, data)
    return response.data
  },
  updateTemplate: async (orgSlug, id, data) => {
    const response = await api.patch(`/${orgSlug}/media-templates/${id}`, data)
    return response.data
  },
  deleteTemplate: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/media-templates/${id}`)
    return response.data
  },
  listSchedules: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/media-schedules`)
    return response.data
  },
  createSchedule: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/media-schedules`, data)
    return response.data
  },
  updateSchedule: async (orgSlug, id, data) => {
    const response = await api.patch(`/${orgSlug}/media-schedules/${id}`, data)
    return response.data
  },
  pauseSchedule: async (orgSlug, id) => {
    const response = await api.patch(`/${orgSlug}/media-schedules/${id}`, { is_active: false })
    return response.data
  },
  deleteSchedule: async (orgSlug, id) => {
    const response = await api.delete(`/${orgSlug}/media-schedules/${id}`)
    return response.data
  },
}
